import axios from 'axios'
import _ from 'lodash'
import flat from 'flat'
import core from '../core'

const {
  constants: { API_URL },
  helpers: { auth, getLoginFromMail, getUserId }
} = core

export const compactData = entry => {
  if (!entry) return {}

  const flatRegister = flat.flatten(entry)
  let compactData = {}

  _.forOwn(flatRegister, (value, key) => {
    switch (key) {
      case _.includes(key, 'person.') ? key : '':
        if (_.includes(key, 'person.id'))
          Object.assign(compactData, { personId: value })

        break

      case _.includes(key, 'primaryReason') ? key : '':
        if (_.includes(key, 'id'))
          Object.assign(compactData, { primaryReasonId: value })
        break

      // case _.includes(key, 'placementPurpose') ? key : '':
      //   if (_.includes(key, 'id') && !_.includes(key, 'valid'))
      //     Object.assign(compactData, { placementPurpose: value })
      //   break

      // case _.includes(key, 'placementStatus') ? key : '':
      //   if (_.includes(key, 'id') && !_.includes(key, 'valid'))
      //     Object.assign(compactData, { placementStatus: value })
      //   break

      case _.includes(key, 'admission.centreNameTo') ? key : '':
        if (_.includes(key, 'id'))
          Object.assign(compactData, { [`admission.centreNameTo`]: value })
        break

      case _.includes(key, 'admission.') ? key : '':
        if (!_.includes(key, 'Age'))
          //&& !_.includes(key, 'Date'))
          Object.assign(compactData, { [`${key}`]: value })
        break

      case _.includes(key, 'discharge.') ? key : '':
        if (!_.includes(key, 'Age'))
          //&& !_.includes(key, 'Date') && !_.includes(key, 'Duration'))
          Object.assign(compactData, { [`${key}`]: value })
        break

      default:
        Object.assign(compactData, { [`${key}`]: value })
        break
    }
  })
  compactData = flat.unflatten(compactData)

  return compactData
}

export const updateHistory = (
  data,
  historyName,
  activeName,
  add = false,
  newHistory,
  editType
) => {
  let history = data[`${historyName}`]
  const newIndex = _.maxBy(history, 'historyId')
    ? _.maxBy(history, 'historyId').historyId !== 'new'
      ? _.maxBy(history, 'historyId').historyId + 1
      : 1
    : 1
  const activeHistory = !add ? data[`${activeName}`] : newHistory

  const audit = {
    active: true,
    editType: (editType && editType * 1) || 1,
    modifiedBy: getLoginFromMail(getUserId()),
    modifiedDate: new Date()
  }
  let dataAdjusted = data
  if (add) {
    if (activeHistory) {
      let value = activeHistory
      value.audit = audit
      value.historyId = newIndex
      if (data.registerId) value.registerId = data.registerId
      history.push(value)
      _.remove(history, ['historyId', 'new'])

      dataAdjusted = {
        ...data,
        [`${activeName}`]: { ...value },
        [`${historyName}`]: history.map((h, i) => ({
          ...h,
          audit: {
            ...h.audit,
            active: i < history.length - 1 ? null : h.audit.active
          }
        }))
      }
    } else {
      let value = data[activeName] //activeHistory
      value.audit = audit
      value.historyId = newIndex
      if (data.registerId) value.registerId = data.registerId
      history.push(value)
      _.remove(history, ['historyId', 'new'])

      dataAdjusted = {
        ...data,
        [`${activeName}`]: { ...value },
        [`${historyName}`]: history.map((h, i) => ({
          ...h,
          audit: {
            ...h.audit,
            active: i < history.length - 1 ? null : h.audit.active
          }
        }))
      }
    }
  } else {
    let value = activeHistory
    value.audit = audit
    value.historyId = newIndex
    if (data.registerId) value.registerId = data.registerId
    history.push(value)
    _.remove(history, ['historyId', 'new'])

    dataAdjusted = {
      ...data,
      [`${activeName}`]: { ...value },
      [`${historyName}`]: history.map((h, i) => ({
        ...h,
        audit: {
          ...h.audit,
          active: i < history.length - 1 ? null : h.audit.active
        }
      }))
    }
  }

  return dataAdjusted
}

export const handlePersonAdd = async (data, personData, persons) => {
  let dataAdjusted = data
  let person = personData

  dataAdjusted = updateHistory(
    dataAdjusted,
    'personHistory',
    'person',
    true,
    person
  )

  let personId = person.id
  delete person['id']
  delete person['age']
  delete person['fullName']
  person.historyId = dataAdjusted.person.historyId

  if (personId !== 'new') {
    // await axios.put(
    //   `${API_URL}/persons/${personId}`,
    //   person,{headers:{authorization: auth(true)}}
    // )
  } else {
    delete person['personId']
    const { data } = await axios.post(`${API_URL}/persons/`, person, {
      headers: { authorization: auth(true) }
    })
    personId = data.id
    dataAdjusted.personId = personId
    dataAdjusted.person = data
  }
  return dataAdjusted
}

export const saveToAPI = async ({ state, props, formValues, ...rest }) => {
  const {
    helpers: { compactData, updateHistory, handlePersonAdd },
    config: { activeSection, ALT_PATH, patch, subFormDetails }
  } = props
  const {
    forms,
    id,
    push,
    snackbar,
    PATH,
    sectionPath,
    // oldSearch,
    persons,
    editType
  } = rest
  const data = formValues
  let person = data && data.person
  const modified = rest.modified || state.modified

  let name = ''
  if (sectionPath) {
    name = `${subFormDetails.label} entry`
  } else {
    name =
      _.includes(activeSection, 'person') || _.get(data, 'person')
        ? `Register entry for ${person.firstName} ${person.lastName}`
        : _.get(data, 'unitName')
          ? data.name
          : data.email
  }

  let dataAdjusted = sectionPath ? data : compactData(data)

  if (!sectionPath) delete dataAdjusted['id']
  delete dataAdjusted['passwordConfirmed']

  modified.map(m => {
    if (m !== 1) {
      const form = _.find(forms, ['id', m])
      if (!sectionPath) {
        dataAdjusted = updateHistory(
          { ...dataAdjusted, person },
          form.historyName,
          form.activeName,
          id === 'new',
          null,
          editType
        )
      } else {
        dataAdjusted = updateHistory(
          dataAdjusted,
          form.historyName,
          form.activeName,
          id === 'new',
          null,
          editType
        )
        delete dataAdjusted.register
      }
    }
    return m
  })

  if (
    //_.includes(modified, 1) &&
    // _.includes(activeSection, 'person')
    person &&
    person.personId === 'new'
  ) {
    dataAdjusted = await handlePersonAdd(dataAdjusted, person, persons)
    delete dataAdjusted['person']
  }

  if (id !== 'new') {
    if (patch) delete dataAdjusted['password']

    patch
      ? await axios.patch(`${API_URL}${ALT_PATH || PATH}${id}`, dataAdjusted, {
          headers: { authorization: auth(true) }
        })
      : await axios.put(`${API_URL}${ALT_PATH || PATH}${id}`, dataAdjusted, {
          headers: { authorization: auth(true) }
        })
    push(`${sectionPath || PATH}`)
    //${oldSearch ? oldSearch : ''}`)
    snackbar(`${name} has been edited succesfully`)
  } else {
    delete dataAdjusted['person']

    await axios.post(`${API_URL}${ALT_PATH || PATH}`, dataAdjusted, {
      headers: { authorization: auth(true) }
    })
    push(`${sectionPath || PATH}`)
    //${oldSearch ? oldSearch : ''}`)
    snackbar(`${name} has been added succesfully`)
  }
}



// WEBPACK FOOTER //
// ./src/common/helpers.js